import { useMutation, useQueryClient } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';
import type { UpdateJobPositionRequest, JobPosition } from '../types/jobPosition.types';
import { JobPositionId } from '@/shared/types/branded.types';

interface UseUpdateJobPositionReturn {
  updateJobPosition: (
    params: { id: string; data: UpdateJobPositionRequest },
    options?: { onSuccess?: () => void; onError?: () => void }
  ) => void;
  updateJobPositionAsync: (params: {
    id: string;
    data: UpdateJobPositionRequest;
  }) => Promise<JobPosition>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
}

export function useUpdateJobPosition(): UseUpdateJobPositionReturn {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateJobPositionRequest }) =>
      jobPositionService.update(JobPositionId(id), data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['job-positions'] });
      queryClient.invalidateQueries({ queryKey: ['job-position'] });
    },
  });

  return {
    updateJobPosition: mutation.mutate,
    updateJobPositionAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
